<template>
  <div class="lp">

    <!-- ===== HERO (이미지) ===== -->
    <section class="lp-hero-img" @click="openRegister">
      <img
        src="@/assets/1.png"
        alt="다음 중 하나라도 해당된다? 지금 당장 보험 점검 시급 — 무료 자가진단 체크리스트"
        class="hero-img" />
    </section>

    <!-- ===== BANNER 2 (이미지) ===== -->
    <section class="lp-img-banner banner-2" @click="openRegister">
      <img
        src="@/assets/2.png"
        alt="가입만 하고 잊고 있던 보험, 무료 보험분석 덕분에 든든한 자산이 되었습니다 — Before/After 비교"
        class="banner-img" />
    </section>

    <!-- ===== BANNER 3 (이미지) ===== -->
    <section class="lp-img-banner banner-3" @click="openRegister">
      <img
        src="@/assets/3.png"
        alt="무료 점검 한 번으로 이렇게 달라집니다 — 보험료 절감·중복보장 정리·보장공백 발견·최신 상품 비교·보험금 청구 도움·1:1 전문가 상담"
        class="banner-img" />
    </section>

    <!-- ===== BANNER 4 (이미지) ===== -->
    <section class="lp-img-banner banner-4" @click="openRegister">
      <img
        src="@/assets/4.png"
        alt="무료 점검 한 번으로 이렇게 달라집니다 — 보험료 절감·중복보장 정리·보장공백 발견·최신 상품 비교·보험금 청구 도움·1:1 전문가 상담"
        class="banner-img" />
    </section>

    <!-- ===== BANNER 5 (이미지) ===== -->
    <section class="lp-img-banner banner-5" @click="openRegister">
      <img
        src="@/assets/5.png"
        alt="실제 고객들이 남긴 보험 점검 후기 — 정말 만족해요"
        class="banner-img" />
    </section>

    <!-- ===== BANNER 6 (이미지) ===== -->
    <section class="lp-img-banner banner-6" @click="openRegister">
      <img
        src="@/assets/6.png"
        alt="실제 고객들이 남긴 보험 점검 후기 — 정말 만족해요"
        class="banner-img" />
    </section>

    <!-- ===== BANNER 7 (이미지) ===== -->
    <section class="lp-img-banner banner-7" @click="openRegister">
      <img
        src="@/assets/7.png"
        alt="간단한 신청, 3단계면 끝 — 무료 점검 신청·전문가 보장분석·맞춤 리포트 안내"
        class="banner-img" />
    </section>

    <!-- ===== BANNER 8 (이미지) ===== -->
    <section class="lp-img-banner banner-8" @click="openRegister">
      <img
        src="@/assets/8.png"
        alt="궁금한 게 있으신가요? 자주 묻는 질문 — 무료 보험점검 신청하기"
        class="banner-img" />
    </section>

    <!-- ===== CTA — 무료 점검 신청 (이미지 톤 매칭) ===== -->
    <section class="lp-cta">
      <div class="cta-inner" v-reveal>
        <span class="cta-badge">✓ 100% 무료 점검</span>
        <h2 class="cta-title">
          지금 바로 신청하고,<br/>
          내 보험 <b>제대로 점검</b>받아보세요!
        </h2>
        <p class="cta-sub">
          1분이면 신청 끝.<br class="cta-br"/>
          전문가가 보장 내용을 알기 쉽게 분석해 드립니다.
        </p>

        <button class="cta-apply" @click="openRegister">
          <span class="cta-apply-ico">→</span>
          무료 보험점검 신청하기
        </button>

        <ul class="cta-trust">
          <li>전문가 보장분석</li>
          <li>맞춤 리포트 제공</li>
          <li>보험료 절감 효과</li>
        </ul>

        <p class="cta-note">
          ※ 본 서비스는 무료 보장분석 상담 안내 페이지이며, 신청 시 기재한 정보는 상담 목적으로만 이용됩니다.
        </p>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  name: 'MainView',
  directives: {
    // 스크롤 진입 시 페이드/슬라이드 등장
    reveal: {
      mounted(el, binding) {
        el.classList.add('reveal')
        const delay = binding.value && binding.value.delay ? binding.value.delay : 0
        if (delay) el.style.transitionDelay = delay + 'ms'
        const io = new IntersectionObserver((entries, obs) => {
          entries.forEach(e => {
            if (e.isIntersecting) {
              el.classList.add('is-revealed')
              obs.unobserve(el)
            }
          })
        }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' })
        io.observe(el)
      }
    }
  },
  methods: {
    openRegister() {
      window.dispatchEvent(new Event('open-register-popup'))
    }
  }
}
</script>

<style scoped>
/* ==================== ROOT / THEME ==================== */
.lp {
  --pk-blue: #142d85;
  --pk-blue-light: #2a45a5;
  --pk-blue-dark: #0d1d5c;
  --pk-accent: #ffd54a;
  background: #ffffff;
  color: #16161C;
  font-family: var(--font-sans);
  letter-spacing: -0.01em;
  overflow-x: hidden;
}

/* ===== 스크롤 등장 애니메이션 ===== */
.reveal {
  opacity: 0;
  transform: translateY(36px);
  transition: opacity 0.9s cubic-bezier(0.16, 1, 0.3, 1),
              transform 0.9s cubic-bezier(0.16, 1, 0.3, 1);
  will-change: opacity, transform;
}
.reveal.is-revealed { opacity: 1; transform: none; }

@media (prefers-reduced-motion: reduce) {
  .reveal { opacity: 1 !important; transform: none !important; transition: none !important; }
}

/* ==================== HERO (이미지) ==================== */
.lp-hero-img {
  padding: 0;
  line-height: 0;
  cursor: pointer;
  background: linear-gradient(180deg, #cfe4fb 0%, #7fb0e6 32%, #0c4c91 100%);
}
.lp-hero-img .hero-img {
  display: block;
  width: 100%;
  max-width: 940px;
  height: auto;
  margin: 0 auto;
}

/* ==================== 이미지 배너 (2.png ~ 8.png) ==================== */
.lp-img-banner {
  padding: 0;
  line-height: 0;
  cursor: pointer;
}
.lp-img-banner .banner-img {
  display: block;
  width: 100%;
  max-width: 940px;
  height: auto;
  margin: 0 auto;
}
.banner-2 { background: linear-gradient(180deg, #ffffff 0%, #ffffff 52%, #2f75dd 100%); }
.banner-3 { background: linear-gradient(180deg, #e4f2fc 0%, #cfe6fb 55%, #1f66cb 100%); }
.banner-4 { background: linear-gradient(180deg, #d8ecfb 0%, #cfe6fb 50%, #0740a0 100%); }
.banner-5 { background: linear-gradient(180deg, #eef7fd 0%, #cfe6fb 50%, #0d4bb7 100%); }
.banner-6 { background: linear-gradient(180deg, #eef7fd 0%, #cfe6fb 50%, #0d4bb7 100%); }
.banner-7 { background: linear-gradient(180deg, #eef7fd 0%, #cfe6fb 50%, #0652bd 100%); }
.banner-8 { background: linear-gradient(180deg, #eef7fd 0%, #cfe6fb 50%, #0452cc 100%); }

/* ==================== CTA (이미지 디자인 톤) ==================== */
.lp-cta {
  padding: 74px 24px 90px;
  text-align: center;
  background: radial-gradient(130% 100% at 50% 0%, #2a45a5 0%, #142d85 55%, #0d1d5c 100%);
  position: relative;
  overflow: hidden;
}
.cta-inner {
  position: relative;
  max-width: 640px;
  margin: 0 auto;
}
.cta-badge {
  display: inline-block;
  font-family: var(--font-rounded);
  font-size: 13px;
  font-weight: 700;
  color: #fff;
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.28);
  padding: 8px 18px;
  border-radius: 999px;
  margin-bottom: 22px;
  letter-spacing: 0.01em;
}
.cta-title {
  font-family: var(--font-rounded);
  font-size: 27px;
  font-weight: 800;
  line-height: 1.42;
  color: #fff;
  letter-spacing: -0.03em;
  word-break: keep-all;
  margin: 0 0 16px;
}
.cta-title b {
  color: var(--pk-accent);
  font-weight: 800;
}
.cta-sub {
  font-family: var(--font-rounded);
  font-size: 15px;
  font-weight: 400;
  line-height: 1.72;
  color: rgba(255, 255, 255, 0.85);
  word-break: keep-all;
  margin: 0 0 34px;
}
.cta-br { display: none; }
.cta-apply {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  background: #fff;
  color: var(--pk-blue);
  border: none;
  border-radius: 999px;
  padding: 16px 32px 16px 18px;
  font-family: var(--font-rounded);
  font-size: 18px;
  font-weight: 800;
  letter-spacing: -0.01em;
  cursor: pointer;
  box-shadow: 0 16px 36px -14px rgba(0, 0, 0, 0.55);
  transition: transform 0.25s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.25s ease;
}
.cta-apply:hover {
  transform: translateY(-3px);
  box-shadow: 0 24px 48px -14px rgba(0, 0, 0, 0.65);
}
.cta-apply-ico {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: var(--pk-blue);
  color: #fff;
  font-size: 18px;
  font-weight: 700;
  line-height: 1;
}
.cta-trust {
  list-style: none;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 12px 24px;
  margin: 34px 0 0;
  padding: 0;
}
.cta-trust li {
  position: relative;
  padding-left: 22px;
  font-family: var(--font-rounded);
  font-size: 13px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.9);
}
.cta-trust li::before {
  content: '✓';
  position: absolute;
  left: 0;
  top: 0;
  color: #7fd0ff;
  font-weight: 800;
}
.cta-note {
  margin: 30px 0 0;
  font-family: var(--font-sans);
  font-size: 11px;
  line-height: 1.75;
  color: rgba(255, 255, 255, 0.5);
  word-break: keep-all;
}

/* ==================== RESPONSIVE (Tablet+) ==================== */
@media (min-width: 768px) {
  .cta-br { display: inline; }
  .lp-cta { padding: 104px 24px 120px; }
  .cta-title { font-size: 36px; }
  .cta-sub { font-size: 17px; }
  .cta-apply { font-size: 19px; padding: 18px 36px 18px 20px; }
  .cta-trust li { font-size: 14px; }
}
</style>
